import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";

import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import PostHogPageviewTracker from './PostHogPageviewTracker';

// Fetch IP address as early as possible to avoid CORS issues later
// This will execute before React even renders
(function() {
  if (!localStorage.getItem('user_ip_address')) {
    console.log('Fetching IP address on app start...');
    const script = document.createElement('script');
    script.text = `
      fetch('https://api.ipify.org/?format=json')
        .then(response => response.json())
        .then(data => {
          console.log('IP address fetched at app start:', data.ip);
          localStorage.setItem('user_ip_address', data.ip);
        })
        .catch(err => {
          console.error('Error fetching IP address at app start:', err);
        });
    `;
    document.head.appendChild(script);
  } else {
    console.log('IP already in localStorage:', localStorage.getItem('user_ip_address'));
  }
})();

posthog.init('phc_xMWG8EdW9ikArxJ14RbWPKs8SSZIfK51S1RtVCFtKVU', {
  api_host: 'https://us.i.posthog.com',
  capture_pageview: false
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <PostHogPageviewTracker />
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </Router>
  </React.StrictMode>
);